// extracted by mini-css-extract-plugin
export var cardBox = "homepage-module--cardBox--5Fkw7";
export var cardBoxFooter = "homepage-module--cardBoxFooter--K5V8M";
export var socialIcon = "homepage-module--socialIcon--HRKQm";
export var supportTitle = "homepage-module--supportTitle--6uDj4";